import './styles.css'
const Button = () => {
    return (
        <button className='btn btn-primary btn-style'>
            <h6>VER CATÁLOGO</h6>
        </button>
    );
}

export default Button;